/**
 * monthly-report-customization — parent plugin
 *
 * This is a container plugin. It does not register any UI extensions directly.
 * Sub-plugins (Phase 6-9) are loaded automatically by ClientPluginLoader
 * using the pluginHierarchy field from GET /api/feature/flags response.
 *
 * IMPORTANT: Sub-plugins must NOT export 'parentPlugin'. Parent-child
 * relationships are resolved from config/tenants/default.json via the API.
 */

export const initPlugin = (): void => {
  // Container plugin — no UI extensions registered at this level.
  // Sub-plugins register their own extensions.
};

// parentPlugin is NOT exported — this IS the parent, not a child plugin.

export const resources_ja: Record<string, string> = {
  'function.MonthlyReportCustomization': '月次レポートカスタマイズ',
};
